<template>
<!-- 图片预览 -->
  <div class="preview_img_show">
    <div class="cur_img__11">
       <img :src="curImg" alt="" :style="{'width': width, 'height': height}">
    </div>
    <div class="left_wraper">
      <div class="pre_ope" @click="pre" v-if="curIndex !== 0"></div>
    </div>
    <div class="right_wraper">
       <div class="next_ope" @click="next" v-if="curIndex < imgList.length - 1"></div>
    </div>
    <div class="close_ope" @click="close">
      <i class="iconfont iconchajianguanbi"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'preview_img_show',
  props: {
    imgList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      curIndex: 0, // 当前下标
      curImg: '', // 当前图片
      width: '',
      height: ''
    }
  },
  mounted() {
    this.curImg = this.imgList[0] ? this.imgList[0].src : ''
    this.handleImg()
  },
  methods: {
    close() {
      this.$emit('close')
    },
    pre() {
      if (this.curIndex !== 0) {
        this.curIndex--
        this.curImg = this.imgList[this.curIndex].src
        this.handleImg()
      }
    },
    next() {
      if (this.curIndex < this.imgList.length - 1) {
        this.curIndex++
        this.curImg = this.imgList[this.curIndex].src
        this.handleImg()
      }
    },
    handleImg() {
      if (!this.curImg) return
      const img = new Image()
      img.src = this.curImg
      const target = document.querySelector('.cur_img__11').getBoundingClientRect()
      if (img.width > img.height) {
        this.width = img.width > target.width ? '100%' : ''
        this.height = ''
      } else if (img.height > img.width) {
        this.height = img.height > target.height ? '100%' : ''
        this.width = ''
      } else {
        this.width = ''
        this.height = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.preview_img_show {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
  .cur_img__11 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // img {
    //  max-width: 100%;
    //  max-height: 100%;
    // }
  }
  .left_wraper {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 15%;
    height: 100%;
    &:hover {
      .pre_ope {
        display: block;
      }
    }
  }
  .pre_ope {
    position: absolute;
    top: calc(50% - 6px);
    left: 35%;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(0, 0, 0, .2);
    cursor: pointer;
    display: none;
    &:after {
      display: inline-block;
      content: '';
      border-style: solid;
      border-width: 11px;
      border-color: transparent;
      border-right-color: rgba(255, 255, 255, 1);
      position: absolute;
      top: 18px;
      left: 12px;
    }
  }
  .right_wraper {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 15%;
    height: 100%;
    &:hover {
      .next_ope {
        display: block;
      }
    }
  }
  .next_ope {
    position: absolute;
    top: calc(50% - 12px);
    right: 35%;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(0, 0, 0, .2);
    cursor: pointer;
    display: none;
    &:after {
      display: inline-block;
      content: '';
      border-style: solid;
      border-width: 11px;
      border-color: transparent;
      border-left-color: rgba(255, 255, 255, 1);
      position: absolute;
      top: 18px;
      right: 12px;
    }
  }
  .close_ope {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(0, 0, 0, .2);
    cursor: pointer;
    position: absolute;
    right: 5%;
    top: 5%;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconchajianguanbi {
      font-size: 24px;
      width: 24px;
      height: 24px;
      color: #FFF;
    }
  }
}
</style>
